<template>
    <div>
        <div class="listing__item" data-aos="fade-up">
            <div class="listing__item--date">
                <span>{{ event.event_date | dateDay }}</span>
                {{ event.event_date | dataMonth }}-
                {{ event.event_date | dateYear }} -
                <span class="time">
                    {{ event.start_time | time }}
                    <i> {{ event.start_time | ampm }}</i> –
                    {{ event.end_time | time }}
                    <i>{{ event.end_time | ampm }}</i></span
                >
            </div>
            <div class="listing__item--body">
                <div class="d-flex justify-content-between">
                    <div class="listing__item--contents">
                        <p class="listing__item--title">{{ event.title }}</p>
                    </div>
                    <div class="listing__item--image" v-if="event.image_field">
                        <img
                            loading="lazy"
                            :src="event.image_field"
                            class="image-top"
                            alt=""
                        />
                        <img loading="lazy" :src="event.image_field" alt="" />
                    </div>
                </div>
                <!-- Likes -->
                <div class="listing__item--info">
                    <ul class="list-inline">
                        <li>
                            <div class="icon">
                                <svg
                                    class="location"
                                    fill="currentColor"
                                    data-name="Layer 1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    viewBox="0 0 384 512"
                                >
                                    <use
                                        xlink:href="#userprofile-location-icon"
                                    ></use>
                                </svg>
                            </div>
                            <span>
                                {{
                                    event.location_type == 'online'
                                        ? $t('Online')
                                        : event.location
                                }}
                            </span>
                        </li>
                        <li>
                            <div class="icon">
                                <svg
                                    class="speaker"
                                    fill="currentColor"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xml:space="preserve"
                                    width="15.4121mm"
                                    height="14.9184mm"
                                    version="1.1"
                                    style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
                                    viewBox="0 0 149.83 145.03"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
                                >
                                    <use
                                        xlink:href="#userprofile-speaker-icon"
                                    ></use>
                                </svg>
                            </div>
                            <span>
                                {{
                                    ideaMembers(event.idea_details.members)
                                }}</span
                            >
                        </li>
                    </ul>
                </div>
            </div>
            <a @click="$emit('showPopUp', $event)" class="abs-link"></a>
        </div>
    </div>
</template>

<script>
import { ideaMembers } from '@/modules/users/mixins/ideaMembers.js'
export default {
    mixins: [ideaMembers],
    components: {},
    props: {
        event: Object,
    },
}
</script>

<style lang="scss" scoped>
/deep/ {
    .listing__item {
        padding-left: rem(30px);
        position: relative;
        &--info {
            svg {
                width: 33px;
                height: auto;
                &.location {
                    width: 25px;
                }
            }
            ul {
                flex-wrap: nowrap;
                li {
                    @include flex(flex-start, flex-start);
                    flex-wrap: nowrap;
                    color: #364798;
                    font-size: rem(18px);
                    line-height: 1.3;
                    &:not(:last-child) {
                        margin-right: rem(60px);
                    }
                    span {
                        width: 150px;
                        font-weight: 600;
                        padding-top: 12px;
                    }
                    .icon {
                        color: var(--primary);
                        margin-right: rem(16px);
                    }
                }
            }
        }
        &--contents {
            flex: 0 0 60%;
            max-width: 60%;
        }
        &--date {
            display: flex;
            align-items: flex-end;
            .time {
                color: #e4d700;
                font-size: rem(25px);
                display: flex;
                align-items: flex-end;
                padding-left: rem(6px);
                i {
                    font-style: normal;
                    font-weight: 600;
                    font-size: rem(15px);
                    margin: 0 rem(6px) rem(3px) rem(6px);
                }
            }
        }
        &--image {
            img {
                max-width: 250px;
            }
        }
        @media screen and (max-width: 1199px) and (min-width: 992px) {
            &--image {
                img {
                    max-width: 200px;
                }
            }
            &--info {
                ul {
                    li {
                        &:not(:last-child) {
                            margin-right: rem(16px);
                        }
                    }
                }
            }
        }
        @media screen and (max-width: 992px) and (min-width: 768px) {
            &--info {
                ul {
                    flex-direction: column;
                    li {
                        &:not(:last-child) {
                            margin-right: 0;
                            margin-bottom: rem(20px);
                        }
                    }
                }
            }
        }
        @media screen and (max-width: 991px) {
            &--image {
                img {
                    max-width: 200px;
                }
            }
            &--info {
                ul {
                    li {
                        &:not(:last-child) {
                            margin-right: rem(20px);
                        }
                    }
                }
            }
        }
        @media screen and (max-width: 767px) {
            .listing {
                &__item {
                    &--contents {
                        flex: 0 0 100%;
                        max-width: 100%;
                        text-align: center;
                        margin: auto;
                    }
                    &--info {
                        ul {
                            justify-content: space-between;
                            li {
                                &:not(:last-child) {
                                    margin-right: 0;
                                }
                            }
                        }
                        svg {
                            width: 25px;
                            &.location {
                                width: 18px;
                            }
                        }
                    }
                    &--title {
                        &:after {
                            left: 50%;
                            transform: translateX(-50%);
                        }
                    }
                }
            }
        }
        @media screen and (max-width: 575px) {
            .listing {
                &__item {
                    &--contents {
                        margin-top: -25px;
                    }
                    &--info {
                        ul {
                            flex-direction: column;
                            li {
                                width: 100%;
                                &:not(:last-child) {
                                    margin-bottom: rem(16px);
                                }
                                .icon {
                                    margin-top: rem(10px);
                                }
                            }
                        }
                    }
                    &--title {
                        font-size: rem(22px);
                    }
                    &--date {
                        padding-left: 0;
                        .time {
                            font-size: rem(18px);
                        }
                        span {
                            font-size: rem(18px);
                        }
                    }
                }
            }
        }
    }
}
.events--date {
    font-size: rem(14px);
    font-weight: 700;
    color: #4a1885;
    span {
        font-size: rem(25px);
        font-weight: 900;
        display: inline-block;
        padding-right: rem(5px);
        &.time {
            color: #4aa803;
            font-size: rem(20px);
            font-weight: 600;
        }
    }
}

// ar style

.ar {
    .listing__item {
        padding-right: rem(30px);
        padding-left: 0;
        &--info {
            ul {
                li {
                    &:not(:last-child) {
                        margin-left: rem(60px);
                        margin-right: 0;
                    }
                    .icon {
                        margin-left: rem(16px);
                        margin-right: 0;
                    }
                }
            }
        }
        &--date {
            direction: ltr;
            align-items: center;
            justify-content: flex-end;
            // .time {
            //     padding-right: rem(6px);
            //     padding-left: 0;
            // }
        }
        @media screen and (max-width: 1199px) and (min-width: 992px) {
            &--info {
                ul {
                    li {
                        &:not(:last-child) {
                            margin-left: rem(16px);
                            margin-right: 0;
                        }
                    }
                }
            }
        }
        @media screen and (max-width: 991px) {
            &--info {
                ul {
                    li {
                        &:not(:last-child) {
                            margin-left: rem(20px);
                            margin-right: 0;
                        }
                    }
                }
            }
        }
        @media screen and (max-width: 767px) {
            .listing {
                &__item {
                    &--info {
                        ul {
                            li {
                                &:not(:last-child) {
                                    margin-left: 0;
                                }
                            }
                        }
                    }
                }
            }
        }
        @media screen and (max-width: 575px) {
            .listing {
                &__item {
                    &--date {
                        padding-right: 0;
                    }
                }
            }
        }
    }
    .events--date {
        span {
            padding-left: rem(5px);
            padding-right: 0;
        }
    }
}
</style>
